export default __webpack_public_path__ + "static/media/demag.de96a36b.svg";